import instance from "../config/axiosConfig";
import {tokenIdentifier} from '../utils/staticData';
import {getToken} from '../config/sessionData';
import {commonReadAddressRoute} from '../config/routes';

export function getAddress(location, callback) {
    let config = {
        headers: {[tokenIdentifier]: getToken()},
        params: {
            lat: location.lat,
            lon: location.lon
        }
    };
    instance
        .get(commonReadAddressRoute, config)
        .then(response => callback(response));
}